import React from "react";

const Footer = () => {
  return (
    <div className="bg-light-pink w-full h-205">
      <div className="container flex justify-center">
        {/* <div className="mt-12">
          <p>LOGO</p>
          <p className="text-sm leading-6 w-456 h-96 mt-3 mb-12">
            We ara a lorem ipsum dolor sit amet, consectetur adipiscing elit,
            sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
            nisi ut aliquip ex ea commodo consequat... Read More
          </p>

          <div className="flex ">
            <div className="flex items-center">
              <FiPhoneCall className="rounded-full bg-lighter-pink-two px-3 h-12 w-12 mr-3" />
              <p className=" mr-14">310-437-2766</p>
            </div>
            <div className="flex items-center">
              <AiOutlineMail className="rounded-full bg-lighter-pink-two px-3 h-12 w-12 mr-3" />
              <p>unreal@outlook.com</p>
            </div>
          </div>

          <div className="flex gap-x-10 mt-14 text-sm font-normal text-gray-color">
            <p>About us</p>
            <p>Contact</p>
            <p>Privacy policy</p>
            <p>Sitemap</p>
            <p>Terms of Use</p>
          </div>
        </div> */}
        {/* <div> */}
          {/* <div className="flex justify-end mt-60 mb-14">
            <AiOutlineFacebook className="rounded-full bg-lighter-pink-two px-3 h-12 w-12 mr-3 " />
            <AiOutlineYoutube className="rounded-full bg-lighter-pink-two px-3 h-12 w-12 mr-3 " />
            <AiOutlineWhatsApp className="rounded-full bg-lighter-pink-two px-3 h-12 w-12 mr-3 " />
            <AiOutlineInstagram className="rounded-full bg-lighter-pink-two px-3 h-12 w-12 mr-3 " />
          </div> */}
          <div className="flex items-end mb-8">
          <p>© 2000-2021, All Rights Reserved</p>
          </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default Footer;
